if (!customElements.get('sv-description')) {
  customElements.define('sv-description', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const body = this.querySelector('[data-sv-description-body]'), button = this.querySelector('button');
      if (!body || !button) return;
      this.classList.add('is-collapsed');
      const update = () => { button.hidden = !this.classList.contains('is-expanded') && body.scrollHeight <= body.clientHeight + 3; };
      const toggle = expanded => {
        this.classList.toggle('is-expanded', expanded); this.classList.toggle('is-collapsed', !expanded);
        button.setAttribute('aria-expanded', String(expanded)); button.textContent = expanded ? button.dataset.less : button.dataset.more;
        update();
      };
      button.addEventListener('click', () => {
        const expanded = !this.classList.contains('is-expanded'); toggle(expanded);
        if (!expanded && button.getBoundingClientRect().top < 0) button.scrollIntoView({ block: 'center' });
      }, { signal: this.abort.signal });
      body.addEventListener('focusin', () => toggle(true), { signal: this.abort.signal });
      this.observer = new ResizeObserver(update); this.observer.observe(body); update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
